import React from 'react'
import ClickableCard from './ClickableCard'
import Card from './Card'

type Props = { onClick: () => void, children: React.ReactNode, className?: string }

const CtaCard: React.FC<Props> = ({ children, onClick, className }) => {
  return (
    <ClickableCard>
      <Card className={`sm:max-w-[310px] min-w-[280px] md:min-h-[80px] grow text-black font-semibold text-sm py-0 px-0 ${className || ''}`}>
        <button onClick={onClick} className='m-0 h-full w-full text-left'>
          {children}
        </button>
      </Card>
    </ClickableCard>
  )
}

export default CtaCard 